<template>
  <div>

    <div class="row mt-1 ml-0">
      <a class="btn-link smaller" href="#"
            @click="addUser">
        <i class="fa fa-plus"></i> Add User
      </a>
    </div>

    <el-table @cell-mouse-enter="rowHover" @cell-mouse-leave="rowHoverLeave"
              @row-click="rowClick"
              id="usersTable" class="table-striped" 
              :data="users" :row-class-name="rowClasses">

      <el-table-column label="Date created" width="120">
        <template slot-scope="{row}">
          {{ dateToString(row.dateCreated) }}
        </template>
      </el-table-column>

      <el-table-column prop="type" label="Type" width="90"/>

      <el-table-column prop="id" label="ID" width="120"/>

      <el-table-column prop="accountId" label="Account ID" width="90"/>

      <el-table-column label="Name">
        <template slot-scope="{row}">
          {{ row ? row.firstName + ' ' + row.lastName : '-' }}
        </template>

      </el-table-column>

      <el-table-column label="Company">
        <template slot-scope="{row}">
          {{ getCompanyName(row) }}
        </template>
      </el-table-column>

      <el-table-column label="User status" width="100">
        <template slot-scope="{row}">
          <div v-tooltip.center-top="row.status == 'active' ? showLastSession(row) : ''">
            {{ row.status }}
          </div>
        </template>
      </el-table-column>

      <el-table-column width="1">
        <template slot-scope="{row}">
          <div :userId="row.type+row.id"/>
        </template>
      </el-table-column>

    </el-table>
  </div>
</template>

<script>
import utils from '../../utils'
export default {
    name: 'Users-Table',
    props: {
      // hidePosition:       {type: Boolean, default: false},
      // hideCompany:        {type: Boolean, default: false},
      // hideLeadsReceived:  {type: Boolean, default: false},
      // hideLeadsClosed:    {type: Boolean, default: false},
      // hideLeads:          {type: Boolean, default: false},
      // hidePayouts:        {type: Boolean, default: false},
      // hideCloseRate:      {type: Boolean, default: false},
      // forCompany:         {type: Object, default: null}
    },
    mounted () {
      this.$store.dispatch('fetchBaseData')
    },
    computed: {
      users () {
        return this.$store.getters.users || []
      }
    },
    methods: {
      dateToString (date) {
        return utils.dateToString(date)
        // return '-'
      },
      addUser () {
        alert(`Not yet implemented`)
      },
      getAffiliateAccount (id) {
        return this.$store.getters.affiliateAccounts.find(a => a.id == id) || {}
      },
      getCompanyName (user) {
        switch (user.type) {
          case 'affiliate':
            return (this.$store.getters.affiliateCompanies.find(c => 
              c.id == this.getAffiliateAccount(user.id).affiliateCompanyId )  || { profile: { companyName: '-'} }).profile.companyName
          case 'incentifyer':
            const company = this.$store.getters.incentifyerAccounts.find(a => a.id == user.accountId)
            if (company && company.profile && company.profile)
              return company.profile.companyName || '-'
            else
              return '-'
          case 'admin':
            return 'Incentify'
          default:
            return '-'
        }
      },
      
      showLastSession (row) {
        if (!row || !row.dateLastSession) return ''
        const d = row.dateLastSession
        return `Last connection:<br>${d.toDateString()}, ${d.toLocaleTimeString()}`
      },

      rowClasses ({row, rowIndex}) {
        return row.archived?'archivedTableRow clickableRow':'clickableRow'
      },
      rowHover(row, column, cell, event) {
        // We show all buttons of class .showOnHover
        var rows = $('#usersTable > div > table > tbody > tr')
        for (var i = 0; i < rows.length; i++) {
          var foundRow = JSON.stringify($(rows[i]).html().indexOf('userid="'+row.type+row.id+'"')) > -1
          var archivedRow = $(rows[i]).attr('class').indexOf('archivedTableRow') > -1
          if (foundRow && !archivedRow) {
            var icons = $(rows[i]).find('.showOnHover')
            for (var j = 0; j < icons.length; j++) {
              $(icons[j]).removeClass('d-none')
            }
            break
          }
        }
      },
      rowHoverLeave (row, column, cell, event) {
        // We hide all buttons of class .showOnHover
        var rows = $('#usersTable > div > table > tbody > tr')
        for (var i = 0; i < rows.length; i++) {
          var index = JSON.stringify($(rows[i]).html().indexOf('userid="'+row.id+'"'))
          if (index > -1) {
            var icons = $(rows[i]).find('.showOnHover')
            for (var j = 0; j < icons.length; j++) {
              $(icons[j]).addClass('d-none')
            }
            break
          }
        }
      },
      rowClick (row, column, event) {
        // We check to see if the click happened on an icon button
        // var match = JSON.stringify(event.toElement.classList.value).match(/fa[rsdl]{0,1}\sfa-/i)
        var path = event.path || event.composedPath() // 2nd one if for Firefox
        var match = JSON.stringify(path[0].className).match(/fa[rsdl]{0,1}\sfa-/i)
        if (match && match.index > -1) {
          // icon button, we ignore row click
        } else {
          //console.log('row click')
          this.editUser(row)
        }
      }
    }
}
</script>

<style>
.el-table__row .cell {
  padding: 0;
}
.has-gutter .is-leaf .cell {
  padding: 0;
}
</style>